import Alpine from 'alpinejs';
import focus from '@alpinejs/focus';
import collapse from '@alpinejs/collapse';
import anchor from '@alpinejs/anchor';
import './Presentation/Template/Fragment/Header';

Alpine.plugin(focus);
Alpine.plugin(collapse);
Alpine.plugin(anchor);

// We use this to enable the AlpineJS debugger in the browser.
if (document.documentElement.dataset.debug != undefined) {
    window.Alpine = Alpine;
}

Alpine.start();
